import { Div } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class Rows extends Div
{
    constructor(rows: appendable[])
    {
        super();
        this.MarginTopBottom(8);

        this.Append(...rows.map(row => new Div("meeting-info-entry").Append(row)));
    }
}
